// เจอนักล่าหรือเหยื่อที่เป็นชนิดจริงแถวที่เราอยู่ (src/geo/neighbors.ts)
// {predator} และ {prey} คือชื่อไทยของชนิดที่ engine เลือกมา ชื่อวิทยาศาสตร์และข้อเท็จจริงขึ้นในกล่อง "รู้ไหม"

import type { GameEvent } from "../../engine/types";

export const ENCOUNTER_EVENTS: readonly GameEvent[] = [
  {
    id: "meet_predator",
    stageTags: ["young", "adult", "old"],
    requires: { encounter: "predator", sessile: false },
    weight: 4,
    text: "{predator}กำลังจ้องมาทางคุณ",
    choices: [
      {
        label: "อยู่นิ่งๆ ซ่อนตัว",
        outcomes: [
          { chance: 0.7, text: "{predator}มองไม่เห็นคุณ และเดินจากไป", effects: { safety: 10 } },
          { chance: 0.3, text: "{predator}พบคุณ! คุณหนีรอดมาได้แต่บาดเจ็บ", effects: { health: -30, addFlags: ["injured"], cause: "predator" } },
        ],
      },
      {
        label: "หนีสุดชีวิต",
        outcomes: [
          { chance: 0.6, text: "คุณหนีพ้น{predator}ได้ทันเวลา", effects: { fullness: -10, safety: 5 } },
          { chance: 0.3, text: "{predator}ไล่ตามมาจนคุณได้แผล แต่ก็หนีพ้น", effects: { health: -20, addFlags: ["injured"], cause: "predator" } },
          { chance: 0.1, text: "{predator}เร็วกว่าที่คิด", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "meet_predator_young",
    stageTags: ["dependent"],
    requires: { encounter: "predator" },
    weight: 4,
    text: "{predator}ด้อมๆ มองๆ อยู่ใกล้ที่ซ่อนของคุณ",
    choices: [
      {
        label: "ซุกตัวนิ่งๆ",
        outcomes: [
          { chance: 0.8, text: "{predator}หาไม่เจอ แล้วก็จากไป", effects: { safety: 5 } },
          { chance: 0.2, text: "{predator}เกือบจับคุณได้ คุณรอดมาอย่างหวุดหวิด", effects: { health: -30, cause: "predator" } },
        ],
      },
      {
        label: "ร้องเรียกพ่อแม่",
        outcomes: [
          { chance: 0.6, text: "พ่อแม่รีบกลับมาไล่{predator}ออกไป", effects: { safety: 10 } },
          { chance: 0.4, text: "เสียงของคุณทำให้{predator}เข้ามาใกล้กว่าเดิม", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "meet_predator_dormant",
    stageTags: ["dormant"],
    requires: { encounter: "predator" },
    weight: 4,
    text: "{predator}กำลังคุ้ยหาอาหารอยู่ใกล้ๆ",
    choices: [
      {
        label: "ภาวนาให้มันไม่เจอ",
        outcomes: [
          { chance: 0.8, text: "{predator}ผ่านไปโดยไม่สังเกตเห็นคุณ", effects: { safety: 5 } },
          { chance: 0.2, text: "{predator}พบคุณเข้า", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "meet_predator_sessile",
    stageTags: ["adult", "old"],
    requires: { encounter: "predator", sessile: true },
    weight: 5,
    text: "{predator}กำลังกินเพื่อนบ้านของคุณทีละตัว ใกล้เข้ามาเรื่อยๆ",
    choices: [
      {
        label: "หดตัวปิดให้แน่นที่สุด",
        outcomes: [
          { chance: 0.7, text: "{predator}เลิกสนใจคุณแล้วไปหาตัวอื่น", effects: { fullness: -10 } },
          { chance: 0.3, text: "{predator}กัดกินคุณไปส่วนหนึ่ง", effects: { health: -30, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "meet_prey",
    stageTags: ["young", "adult", "old"],
    requires: { encounter: "prey", sessile: false },
    weight: 5,
    text: "คุณเห็น{prey}อยู่ไม่ไกล",
    choices: [
      {
        label: "เข้าไปจับเลย",
        outcomes: [
          { chance: 0.6, text: "คุณจับ{prey}ได้ มื้อนี้อิ่มไปอีกนาน", effects: { fullness: 35 } },
          { chance: 0.4, text: "{prey}รู้ตัวและหนีไปได้", effects: { fullness: -5 } },
        ],
      },
      {
        label: "รอให้มันเข้ามาใกล้กว่านี้",
        outcomes: [
          { chance: 0.45, text: "{prey}เข้ามาในระยะพอดี คุณจับได้โดยแทบไม่ต้องออกแรง", effects: { fullness: 30, safety: 5 } },
          { chance: 0.55, text: "{prey}เปลี่ยนทางไปที่อื่น", effects: { fullness: 0 } },
        ],
      },
    ],
  },
];
